import React, {useEffect} from 'react'


const Group = ({item, formId}) => {
  const groupRef = React.useRef(null);
  
  const handleMoveChild = (e)=> {
    //.dynamicFormElements_c425758d-f4a5-42cb-83e4-bc57944c92a7_user_scan_script
    //.dynamicFormElements_8af4e0f6-dffb-4b12-b096-6ebf4ce144ef_user_scan_script
    
    const childElements = item.child.map((child)=> `.dynamicFormElements_${formId}_${child}`).join(' , ');
    const elements = document.querySelectorAll(childElements)
    //console.log('elements---->', elements, childElements)
    elements.forEach(element => {
      const parent = element.parentNode;
      if (parent) {
        parent.removeChild(element); // Explicitly remove the element from its current parent
      }
      groupRef.current.appendChild(element);
    });
  }
  
  useEffect(() => {
    handleMoveChild();
  }, []);
  
  return (
    <>
      
      <div className={`${item.className || ''}`}>
        <div className={`flex flex-col ${item.headerClassName || ''}`}>
          {item.description && <div className=" text-gray-500 text-sm font-normal border-b border-b-gray-300 pb-md">{item.description}</div>}
          <div ref={groupRef} className={`pt-md ${item.layoutStyle || ''}`}></div>
        
        </div>
      </div>
    
    </>
  )
}

export default Group
